/**
 * Created by Michał Stawski on 03.04.2019.
 */

import React from 'react'
import { connect } from 'react-redux'
import { clientAction } from '../../reducers/restApi'
import { withStyles, withWidth } from '@material-ui/core'
import { reduxForm, reset, SubmissionError } from 'redux-form'
import { cleanValues } from '../../reducers/schema'
import { CLIENT_ACTION_SUCCESS } from 'redux-coreapi'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Typography from '@material-ui/core/Typography'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import StoryAddDialog from './StoryAddDialog'
import AddIcon from '@material-ui/icons/Add'
import SearchIcon from '@material-ui/icons/Search'
import * as ReactDOM from 'react-dom'
import tree_of_burdens from '../../media/tree_of_burdens/tree_of_burdens_buckeye.png'
import Button from '@material-ui/core/Button'

export const BURDEN_TREE = 'BURDEN_TREE'

const styles = theme => ({
  burdenTree: {
    width: '100%',
    backgroundImage: `url('${tree_of_burdens}')`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '70%',
    minHeight: 1300
  },
  leftLeaves: {
    textAlign: 'center',
    // border: '1px solid black'
  },
  svgConnector: {
    textAlign: 'center',
    height: '100%'
  },
  svgConnectorSvg: {
    height: '100%',
    // TODO better handle svg size
    overflow: 'visible'
  },
  rightLeaves: {
    textAlign: 'center',
    // border: '1px solid black'
  },
  trunk: {
    textAlign: 'center',
    // marginTop: 700
    // border: '1px solid black'
  },
  rootBurdensSVG: {
    width: '100%',
    // border: '1px solid blue',
  },
  rootBurdens: {
    textAlign: 'center',
    width: '100%',
    // border: '1px solid black',
    display: 'flex',
    alignContent: 'space-around',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  yearButton: {
    backgroundColor: 'green'
  },
  rightLeaf: {
    // border: '1px solid green'
    // border: '2px solid tan',
    marginTop: 200,
    borderRadius: 8,
    backgroundColor: '#9a0000',
    color: 'white',
  },
  leftLeaf: {
    // border: '1px solid green'
    // border: '2px solid tan',
    marginTop: 200,
    borderRadius: 8,
    backgroundColor: '#9a0000',
    color: 'white',
  },
  potential: {
    // border: '2px solid brown',
    width: 'min-content',
    margin: 20,
    padding: 10,
    borderRadius: 8,
    backgroundColor: '#9a0000',
    color: 'white',
  },

  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    // flexBasis: '33.33%',
    flexShrink: 0,
    backgroundColor: '#6c0000',
    color: 'white',
    textAlign: 'center'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  expansionDetails: {
    width: '100%',
    backgroundColor: '#9a0000',
    color: 'white',
  },

  fab: {
    // position: 'relative',
    // top: theme.spacing.unit,
    // left: theme.spacing.unit,
    border: 'solid 5px #000000',
    backgroundColor: '#d80000',
    borderRadius: 19,
    color: 'white',
    // height: 100,
    width: '100%',
    fontSize: 14,
    marginBottom: 600
  },
  addIcon: {
    fontSize: 47
  },
  leavesHeader: {
    fontSize: 48,
    fontWeight: 'bold',
    textTransform: 'uppercase',

  },
  wholeTree: {
    width: '100%'

  },
  exploreButton: {
    textTransform: 'uppercase',
    backgroundColor: '#a20202',
    height: 60,
    display: 'flex',
    borderRadius: 10,
    color: 'white',
    fontSize: 15,
    fontWeight: 'bold',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'translateY(8px)'
  },
  expansionSummary: {
    backgroundColor: '#6c0000',
    color: 'white',
    display: 'flex',
    borderBottom: 'solid 1px rgba(216, 0, 0, 0.43)',
    borderLeft: 'solid 1px rgba(216, 0, 0, 0.43)',
    borderRight: 'solid 1px rgba(216, 0, 0, 0.43)',
    justifyContent: 'center',

  },
  detailsPanel: {
    backgroundColor: '#9a0000',
    color: 'white',
  },
  chooseButton: {
    fontSize: 11,
    fontWeight: 'bold',
    backgroundColor: '#d80000',
    color: 'white',
    padding: 10

  },
  colorWhite: {
    color: 'white',
  }

})

class ControlledExpansionPanels extends React.Component {
  state = {
    expanded: null,
  }

  constructor (props) {
    super(props)
    this.eventRefs = {}
  }

  setEventRef (id) {
    return (ref) => {
      this.eventRefs[id] = ref
    }
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    })
  }

  render () {
    const { classes, eventYears, onEventClick } = this.props
    const { expanded } = this.state

    return (
      <div className={classes.root}>
        {eventYears && eventYears.map((yearContainer) =>
          <ExpansionPanel expanded={expanded === yearContainer.year} onChange={this.handleChange(yearContainer.year)}
                          key={yearContainer.year}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>} classes={{
              root: classes.expansionSummary,
            }}>
              <Typography className={classes.heading}>{yearContainer.year}</Typography>
              {/*<Typography className={classes.secondaryHeading}>I am an expansion panel</Typography>*/}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails classes={{ root: classes.detailsPanel }}>
              <div className={classes.expansionDetails}>
                {yearContainer.events.map((event) => {
                  return <div key={event.id}
                              ref={this.setEventRef(event.id)}
                  >
                    <Typography variant='h6' className={classes.colorWhite}>
                      {event.name}
                    </Typography>
                    <Typography variant='subheading' className={classes.colorWhite}>
                      {event.parsedDate.format('d MMM')}
                    </Typography>
                    <Typography className={classes.colorWhite}>
                      {event.description}
                    </Typography>
                    <Button onClick={onEventClick(event.id)} className={classes.chooseButton}>
                      CHOOSE
                    </Button>

                  </div>
                })

                }
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )}
      </div>
    )
  }
}

let viewBoxWidth = 100
let viewBoxHeight = 300

let rootViewBoxWidth = 900
let rootViewBoxHeight = 100

function rectToY (rect, containerRect) {
  return rect.y + rect.height / 2 - containerRect.y
}

function rectToX (rect, containerRect) {
  return rect.x + rect.width / 2 - containerRect.x
}

const YearExpansionPanels = ControlledExpansionPanels

const Curve = ({ startPoint, endPoint, horizontal = true }) => {
  let instructions
  if (horizontal) {
    instructions = `
      M ${startPoint.x},${startPoint.y}
      C ${endPoint.x},${startPoint.y}
        ${startPoint.x},${endPoint.y}
        ${endPoint.x},${endPoint.y}
    `
  } else {
    instructions = `
      M ${startPoint.x},${startPoint.y}
      C ${startPoint.x},${endPoint.y}
        ${endPoint.x},${startPoint.y}
        ${endPoint.x},${endPoint.y}
    `
  }

  return <path
    d={instructions}
    fill="none"
    stroke="rgb(194, 0, 0)"
    strokeWidth={5}
  />
}

class BurdenTreeSegment extends React.Component {
  state = {
    eventYears: [],
    leavesLeft: {},
    leavesRight: {},
    roots: {},
    dialogOpen: false,
    selectedId: null,
    leftCurves: [],
    rightCurves: [],
    rootCurves: []
  }

  constructor (props) {
    super(props)
    this.leftLeafRefs = {}
    this.rightLeafRefs = {}
    this.rootRefs = {}
    this.leftSvg = React.createRef()
    this.rightSvg = React.createRef()
    this.rootsSvg = React.createRef()
    this.eventRef = React.createRef()
    this.containerRef = React.createRef()
    this.redrawSvg = false
  }

  setRootRef (id) {
    return (ref) => {
      if (ref) {
        this.rootRefs[id] = ref
      } else {
        delete this.rootRefs[id]
      }
    }
  }

  setLeftLeafRef (id) {
    return (ref) => {
      if (ref) {
        this.leftLeafRefs[id] = ref
      } else {
        delete this.leftLeafRefs[id]

      }
    }
  }

  setRightLeafRef (id) {
    return (ref) => {
      if (ref) {
        this.rightLeafRefs[id] = ref
      } else {
        delete this.rightLeafRefs[id]
      }
    }
  }

  componentDidMount () {
    this.props.listEvents()
    this.props.listPotential()
    this.props.listStory()
    this.props.listPerson()
  }

  handleClose () {
    this.setState({ dialogOpen: false })
  }

  handleAdd () {
    this.setState({ dialogOpen: true })
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (nextProps.treeEvent !== this.props.treeEvent ||
      nextProps.treeStory !== this.props.treeStory

    ) {
      let eventYears = []
      let item, year
      let events = nextProps.treeEvent
      if (events && events.data) {
        for (let id of events.index) {
          item = events.data[id].instance
          item.parsedDate = new moment(item.date)
          year = item.parsedDate.year()
          if (!eventYears[year]) {
            eventYears[year] = { year, events: [] }
          }
          eventYears[year].events.push(item)
        }
      }
      this.setState({ eventYears })
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    // if (this.redrawSvg) {
    if (this.state.selectedId !== prevState.selectedId) {
      if (this.eventRef.current && this.state.selectedId) {
        // let size = this.props.getSize(this.eventRef.current.getBoundingClientRect())
        let eventRect = ReactDOM.findDOMNode(this.eventRef.current.eventRefs[this.state.selectedId]).getBoundingClientRect()
        let containerRect = ReactDOM.findDOMNode(this.containerRef.current).getBoundingClientRect()
        let leftCurves = []
        let rightCurves = []
        let rootCurves = []

        let leftRects = Object.values(this.leftLeafRefs).map(
          (item) => ReactDOM.findDOMNode(item).getBoundingClientRect()
        )
        let rightRects = Object.values(this.rightLeafRefs).map(
          (item) => ReactDOM.findDOMNode(item).getBoundingClientRect()
        )
        let rootRects = Object.values(this.rootRefs).map(
          (item) => ReactDOM.findDOMNode(item).getBoundingClientRect()
        )
        let svgHS = this.leftSvg.current.height.baseVal.value
        let viewBoxScaleH = viewBoxHeight / svgHS
        let i = 0
        for (let rect of leftRects) {
          leftCurves.push({
            startPoint: { x: 0, y: rectToY(rect, containerRect) * viewBoxScaleH },
            endPoint: { x: viewBoxWidth, y: rectToY(eventRect, containerRect) * viewBoxScaleH },
            key: i++
          })
        }
        i = 0
        for (let rect of rightRects) {
          rightCurves.push({
            startPoint: { x: viewBoxWidth, y: rectToY(rect, containerRect) },
            endPoint: { x: 0, y: rectToY(eventRect, containerRect) },
            key: i++
          })
        }
        let svgWS = this.rootsSvg.current.width.baseVal.value
        let rootViewBoxScale = rootViewBoxWidth / svgWS
        i = 0
        for (let rect of rootRects) {
          rootCurves.push({
            startPoint: { x: rectToX(rect, containerRect) * rootViewBoxScale, y: rootViewBoxHeight },
            endPoint: { x: rectToX(eventRect, containerRect) * rootViewBoxScale, y: 0 },
            key: i++
          })
        }

        console.log(eventRect, leftRects, rightRects, rootRects)
        this.setState({ leftCurves, rightCurves, rootCurves })
      }

      this.redrawSvg = false
    }
  }

  fillLeavesFromEvent (id) {
    let leavesLeft = {}
    let leavesRight = {}
    let roots = {}
    let i, item, ip, potential
    if (this.props.treeStory && this.props.treeStory.data &&
      this.props.treePerson && this.props.treePerson.data) {
      for (i of this.props.treeStory.index) {
        item = this.props.treeStory.data[i].instance
        if (item.event === id) {
          leavesLeft[item.id] = item
          for (ip of item.potentials) {
            potential = this.props.treePotential.data[ip].instance
            roots[potential.id] = potential
          }
        }
      }

      console.log({ leavesLeft, leavesRight, roots })
      this.setState({ leavesLeft, leavesRight, roots, selectedId: id })
    }
  }


  render () {
    let {
      classes,
    } = this.props
    let {
      eventYears, leavesLeft, roots,
      leftCurves, rightCurves, rootCurves
    } = this.state

    return <div className={classes.wholeTree}>
      <Grid container className={classes.burdenTree} justify={'center'} spacing={0}
            ref={this.containerRef}
      >
        <Grid item xs={3} className={classes.leftLeaves}>
          {/*left leaves*/}
          <Typography variant="h6" className={classes.leavesHeader}>
            Stories
          </Typography>
          {
            Object.values(leavesLeft).map((i) => {
              return <div key={i.id} className={classes.leftLeaf}
                          ref={this.setLeftLeafRef(i.id)}
              >
                <Typography variant="h6" className={classes.colorWhite}>
                  {i.name}
                </Typography>
                <Typography variant="subheading" className={classes.colorWhite}>
                  Age: {i.age}
                </Typography>

                <Typography variant="body1" className={classes.colorWhite}>
                  {i.description}
                </Typography>
              </div>
            })
          }
        </Grid>
        <Grid item xs={1} className={classes.svgConnector}>
          {/* left leaves connector*/}
          <svg
            ref={this.leftSvg}
            viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
            className={classes.svgConnectorSvg}
          >
            {leftCurves.map((curve) =>
              <Curve startPoint={curve.startPoint} endPoint={curve.endPoint} key={curve.key}/>
            )}
          </svg>
        </Grid>
        <Grid item xs={3} className={classes.trunk}>
          <Button color="primary" aria-label="add"
                  className={classes.fab}
                  onClick={() => this.handleAdd()}
          >
            <AddIcon className={classes.addIcon}/> Add Your Story
          </Button>
          <Typography variant="h6" className={classes.exploreButton}>
            <SearchIcon className={classes.addIcon}/>
            Explore Events
          </Typography>
          <YearExpansionPanels
            classes={classes}
            eventYears={eventYears}
            ref={this.eventRef}
            onEventClick={(id) => (event) => {
              // console.log(event.currentTarget.getBoundingClientRect())
              this.fillLeavesFromEvent(id)
              if (this.eventRef.current) {
                console.log(this.eventRef.current)
                console.log(this.eventRef.current.eventRefs[id])
              } else {
                console.log('eventRef  no', this.eventRef.current, this.eventRef)
              }

            }}
          />
        </Grid>
        <Grid item xs={1} className={classes.svgConnector}>
          {/* right leaves connector*/}
          <svg
            ref={this.rightSvg}
            viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
            className={classes.svgConnectorSvg}
          >
            {rightCurves.map((curve) =>
              <Curve startPoint={curve.startPoint} endPoint={curve.endPoint} key={curve.key}
              />
            )}
          </svg>
        </Grid>
        <Grid item xs={3} className={classes.rightLeaves}>
          {/*right leaves*/}
          <Typography variant="h6" className={classes.leavesHeader}>
            Persons
          </Typography>
          {Object.values(leavesLeft).map((i) => {
            return <div key={i.id}>
              {i.persons && Object.values(i.persons).map((person) => {
                return <div key={person.id} className={classes.rightLeaf}
                            ref={this.setRightLeafRef(person.id)}
                >
                  <Typography variant="h6" className={classes.colorWhite}>
                    {person.name}
                  </Typography>
                  <Typography variant="body1" className={classes.colorWhite}>
                    Story: {person.description}
                  </Typography>
                </div>
              })}
            </div>
          })
          }
        </Grid>
      </Grid>
      <div className={classes.rootBurdensSVG}>
        {/*roots svg connector*/}
        <svg
          ref={this.rootsSvg}
          viewBox={`0 0 ${rootViewBoxWidth} ${rootViewBoxHeight}`}
        >
          {rootCurves.map((curve) =>
            <Curve startPoint={curve.startPoint} endPoint={curve.endPoint} key={curve.key}
                   horizontal={false}
            />
          )}
        </svg>
      </div>
      <div className={classes.rootBurdens}>
        {Object.values(roots).map((i) => {
          return <div key={i.id} className={classes.potential}
                      ref={this.setRootRef(i.id)}
          >
            <Typography variant="h6" className={classes.colorWhite}>
              {i.name}
            </Typography>
            <Typography variant="body1" className={classes.colorWhite}>
              {i.description}
            </Typography>
          </div>
        })
        }

      </div>
      <StoryAddDialog open={this.state.dialogOpen}
                      handleClose={() => this.handleClose()}/>
    </div>
  }
}

const onSubmit = (values, dispatch, props) => {
  dispatch((dispatch, getState) => {
    let sub
    values = { ...values }
    let state = getState()
    values.article_subsegment = props.articleSubsegment
    try {
      let objectType = 'comments'
      if (values && values.id) {
        console.log('why are You here')
        cleanValues(values, state, objectType, 'update')
        sub = dispatch(clientAction([objectType, 'update'], values))
      } else {
        cleanValues(values, state, objectType, 'create')
        sub = dispatch(clientAction([objectType, 'create'], values))
      }
      if (sub.type) {
        console.error(sub)
      } else {
        sub.then(
          success => {
            if (success.type === CLIENT_ACTION_SUCCESS) {
              dispatch(reset('commentSubmitForm'))
              // props.handleClose()
            } else {
              // dispatch(openSnackbar({message: 'Save Problem', autoHideDuration: 5000}));
              throw new SubmissionError('Save Problem')
            }
          }
        )
      }
    } catch (e) {
      console.error(e)
      throw new SubmissionError(e.validationErrors)
    }
  })
}
export default connect(
  (state) => (
    {
      schema: state.schema.schema,
      treeEvent: state.restApi.treeEvent,
      treePotential: state.restApi.treePotential,
      treeStory: state.restApi.treeStory,
      treePerson: state.restApi.treePerson,
    }
  ),

  (dispatch) => ({
    listEvents: () => dispatch(clientAction(['treeEvent', 'list'])),
    listPotential: () => dispatch(clientAction(['treePotential', 'list'])),
    listStory: () => dispatch(clientAction(['treeStory', 'list'])),
    listPerson: () => dispatch(clientAction(['treePerson', 'list'])),

  })
)(withWidth()(withStyles(styles)(
  reduxForm({
    /** @namespace state.form.commentSubmitForm **/
    form: 'commentSubmitForm',
    enableReinitialize: false,
    onSubmit
  })(BurdenTreeSegment))
))
